// disable-input.directive.ts
import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appDisableInput]'
})
export class DisableInputDirective {

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    event.preventDefault(); // Prevent any key press actions
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    (event.target as HTMLInputElement).value = ''; // Clear any input
  }
}
